webpackJsonp([217434727830007],{

/***/ 1237:
/***/ (function(module, exports) {

	module.exports = {"data":{"mapsJson":{"name":"Big Game Hunters","description":"Each player gets an extra [2 gold] during each of their upkeeps.","filename":"map_big_game_hunters.jpg","slug":"big_game_hunters"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"big_game_hunters","imageRegex":"/big_game_hunters.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---map-big-game-hunters-931002bce12720a3df5c.js